import { render, staticRenderFns } from "./luckEditFields.vue?vue&type=template&id=3f6b0ae8&scoped=true"
import script from "./luckEditFields.vue?vue&type=script&lang=js"
export * from "./luckEditFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b0ae8",
  null
  
)

export default component.exports